import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { storage } from '../../firebase/firebase.config';
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from 'firebase/storage';
import Loading from '../loading/Loading';

const API = 'https://us-central1-inprojuy-f1173.cloudfunctions.net/app';

function CargarVideo() {
  const [titulo, setTitulo] = useState('');
  const [descripcion, setDescripcion] = useState('');
  const [fileVideo, setFileVideo] = useState(null);
  const [fileThumbnail, setFileThumbnail] = useState(null);
  const [previewThumb, setPreviewThumb] = useState(null);
  const [progreso, setProgreso] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [videos, setVideos] = useState([]);

  const cargarVideos = () => {
    axios.get(`${API}/videos`)
      .then((res) => setVideos(Array.isArray(res.data) ? res.data : []))
      .catch((err) => console.error('Error al obtener videos:', err));
  };

  useEffect(() => {
    cargarVideos();
  }, []);

  useEffect(() => {
    if (!fileThumbnail) { setPreviewThumb(null); return; }
    const url = URL.createObjectURL(fileThumbnail);
    setPreviewThumb(url);
    return () => URL.revokeObjectURL(url);
  }, [fileThumbnail]);

  const generarThumbnail = (file) => {
    return new Promise((resolve) => {
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.muted = true;
      video.playsInline = true;
      const url = URL.createObjectURL(file);
      video.src = url;
      video.onloadeddata = () => {
        video.currentTime = 1; // captura el frame al segundo 1
      };
      video.onseeked = () => {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d').drawImage(video, 0, 0);
        URL.revokeObjectURL(url);
        canvas.toBlob((blob) => {
          const thumbFile = new File([blob], 'thumbnail.jpg', { type: 'image/jpeg' });
          resolve(thumbFile);
        }, 'image/jpeg', 0.85);
      };
      video.onerror = () => { URL.revokeObjectURL(url); resolve(null); };
    });
  };

  const subirArchivo = (file, path) =>
    new Promise((resolve, reject) => {
      const storageRef = ref(storage, path);
      const task = uploadBytesResumable(storageRef, file);
      task.on(
        'state_changed',
        (snap) => setProgreso(Math.round((snap.bytesTransferred / snap.totalBytes) * 100)),
        reject,
        async () => {
          const url = await getDownloadURL(task.snapshot.ref);
          resolve(url);
        }
      );
    });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!fileVideo || !titulo.trim()) {
      alert('Por favor completá el título y seleccioná un video.');
      return;
    }
    setIsSubmitting(true);
    setProgreso(0);
    try {
      const ts = Date.now();
      const urlVideo = await subirArchivo(fileVideo, `videos/${ts}_${fileVideo.name}`);
      let urlThumb = '';
      if (fileThumbnail) {
        urlThumb = await subirArchivo(fileThumbnail, `videos/thumbs/${ts}_${fileThumbnail.name}`);
      }
      await axios.post(`${API}/videos`, {
        titulo: titulo.trim(),
        descripcion: descripcion.trim(),
        url: urlVideo,
        thumbnail: urlThumb,
      });
      alert('Video cargado correctamente.');
      setTitulo('');
      setDescripcion('');
      setFileVideo(null);
      setFileThumbnail(null);
      setProgreso(0);
      cargarVideos();
    } catch (err) {
      console.error(err);
      alert('Error al cargar el video. Revisá la consola.');
    }
    setIsSubmitting(false);
  };

  const handleEliminar = async (docId) => {
    if (!window.confirm('¿Seguro que querés eliminar este video?')) return;
    try {
      await axios.delete(`${API}/videos/${docId}`);
      cargarVideos();
    } catch (err) {
      console.error(err);
      alert('Error al eliminar el video.');
    }
  };

  return (
    <div className="fondotransparente container">
      {isSubmitting && <Loading />}

      <center>
        <h2 className="botonbordeazul text-white px-5 py-3 mb-4">Cargar Video</h2>
      </center>

      {/* Lista de videos cargados */}
      <h4>Videos cargados actualmente:</h4>
      {videos.length === 0 ? (
        <p className="text-muted">No hay videos cargados.</p>
      ) : (
        <div className="row g-3 mb-4">
          {videos.map((v) => (
            <div key={v.docId} className="col-md-4">
              <div className="card h-100">
                {v.thumbnail ? (
                  <img src={v.thumbnail} alt={v.titulo} className="card-img-top" style={{ maxHeight: 150, objectFit: 'cover' }} />
                ) : (
                  <div className="d-flex align-items-center justify-content-center bg-secondary text-white" style={{ height: 150 }}>
                    Sin miniatura
                  </div>
                )}
                <div className="card-body d-flex flex-column">
                  <h6 className="card-title">{v.titulo}</h6>
                  {v.descripcion && <p className="card-text small text-muted">{v.descripcion}</p>}
                  <p className="card-text small text-muted mt-auto">Cargado: {v.fechacarga}</p>
                  <button
                    className="btn btn-danger btn-sm mt-2"
                    onClick={() => handleEliminar(v.docId)}
                  >
                    Eliminar
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Formulario de carga */}
      <div className="p-3 border rounded-3 bg-white">
        <h5 className="mb-3">Subir nuevo video</h5>
        <form onSubmit={handleSubmit} className="row g-3">
          <div className="col-12">
            <label className="form-label">Título *</label>
            <input
              type="text"
              className="form-control"
              value={titulo}
              onChange={(e) => setTitulo(e.target.value)}
              required
            />
          </div>
          <div className="col-12">
            <label className="form-label">Descripción (opcional)</label>
            <input
              type="text"
              className="form-control"
              value={descripcion}
              onChange={(e) => setDescripcion(e.target.value)}
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Archivo de video * (mp4, webm)</label>
            <input
              type="file"
              className="form-control"
              accept="video/mp4,video/webm"
              onChange={async (e) => {
                const file = e.target.files[0] || null;
                setFileVideo(file);
                if (file) {
                  const thumb = await generarThumbnail(file);
                  if (thumb) {
                    setFileThumbnail(thumb);
                    setPreviewThumb(URL.createObjectURL(thumb));
                  }
                }
              }}
              required
            />
            {fileVideo && <small className="text-muted">{fileVideo.name} ({(fileVideo.size / 1024 / 1024).toFixed(1)} MB)</small>}
          </div>
          <div className="col-md-6">
            <label className="form-label">Miniatura (se genera automática, o podés reemplazarla)</label>
            <input
              type="file"
              className="form-control"
              accept="image/jpeg,image/png"
              onChange={(e) => {
                const file = e.target.files[0] || null;
                setFileThumbnail(file);
                if (file) setPreviewThumb(URL.createObjectURL(file));
              }}
            />
            {previewThumb && (
              <img src={previewThumb} alt="preview" style={{ maxWidth: '100%', marginTop: 8, borderRadius: 6 }} />
            )}
          </div>

          {isSubmitting && progreso > 0 && (
            <div className="col-12">
              <div className="progress">
                <div
                  className="progress-bar progress-bar-striped progress-bar-animated"
                  style={{ width: `${progreso}%` }}
                >
                  {progreso}%
                </div>
              </div>
            </div>
          )}

          <div className="col-12">
            <button className="btn btn-success" type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Subiendo...' : 'Subir video'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default CargarVideo;
